import styled from 'styled-components';

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  height: 1px;
  background-color: #d9d9d9;
  margin: 0 20px;
`;
